// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"IconButton_buttonWrapper__OgDkM","disabled":"IconButton_disabled__UBIwy"};